import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LdsUserService } from '../../services/lds-user.service';
import { FeatureSetData, FeatureData } from '../../interfaces/data-analytics';
import { map } from 'rxjs/operators';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { DataAnalyticsService } from '../../data-analytics/data-analytics.service';
import { IconsService } from '../../services/icons.service';
import { DemoAccountService } from '../../demo-account.service';
import { PopupComponent } from '../../common-components/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { DataExportService } from '../../services/data-export.service';
import { TimeSelectComponent } from '../../time-select/time-select.component';
import { ActiveGraphService } from '../../lds-graph/active-graph.service';
import { time } from '../../services/global-variables.service';
@Component({
    selector: 'lds-lds-energy-detail',
    templateUrl: './lds-energy-detail.component.html',
    styleUrls: ['./lds-energy-detail.component.css'],
    standalone: false
})
export class LdsEnergyDetailComponent implements OnInit {

    constructor(private route: ActivatedRoute, public icons: IconsService,
        private activeGraph: ActiveGraphService, private user: LdsUserService, private rout: Router, private eventBus: LdsEventBusService, private dataAnalytics: DataAnalyticsService, private demo: DemoAccountService,
        private dialog: MatDialog, private dataExport: DataExportService) { }
    public deviceType: string;
    public features: FeatureData[];
    public daily_data;
    public hasNoData: boolean;
    public eco7Data;
    public hourlyAverage;
    public featureSet;
    public icon_margin;
    public showLinkBtns;
    public startTime;
    public endTime;
    public room;
    public timespan: string;
    public currentTimespanString: string = "";
    private featuresToShow = ['dimLevel', 'switch', 'movement', 'energy', 'power',
        'temperature', 'targetTemperature'/*, 'batteryLevel'*/, 'buttonPress', 'windowPosition', 'valveLevel'];
    ngOnInit() {
        this.user.loading = true;
        this.timespan = "weekly";
        this.route.params.pipe(map(params => params['id'])).subscribe((id) => {
            this.eventBus.subscribeAll([id, 'energy-featureSets-loaded-from-storage'], () => {
                this.user.currentModule = this.user.energyFeatureSets[id].name;
                this.featureSet = this.user.energyFeatureSets[id];
                this.showGraph(this.featureSet);
                this.showHourlyDistribution(this.featureSet.featureId);
                this.room = this.user.getRoom(this.featureSet);
                if (this.room) {
                    this.user.currentModule = this.featureSet.name + " - " + this.room.name;
                }
            });
        });
        const hasSwitch = (featureId) => {
            const feature = this.user.features[featureId];
            return feature.attributes.type === 'switch';
        };
        this.showLinkBtns = this.featureSet.features.find(hasSwitch);

    }

    private async showGraph(featureSet: FeatureSetData) {
        let featuresBuffer = [];
        for (let index = 0; index < featureSet.features.length; index++) {
            const element = this.user.features[featureSet.features[index]];
            if (this.featuresToShow.indexOf(element.attributes.type) >= 0) {
                featuresBuffer.push(element);
            }
        }
        this.deviceType = featureSet.type;
        this.features = featuresBuffer;


        if (!this.daily_data) {
            if (this.timespan === "custom") {
                this.hasNoData = true;
                this.user.loading = false;
                return;
            }

            let currentDate = Date.now();
            switch (this.timespan) {
             
                case "weekly":
                    if (!this.featureSet.daily_data) {
                        this.hasNoData = true;
                        this.user.loading = false;
                        return;
                    }
                 
                    let startDate = new Date(currentDate - time.day * 7);

                    this.daily_data = this.featureSet.daily_data;
                    break;
                case "monthly":
                    if (!this.featureSet.monthly_data) {
                        this.hasNoData = true;
                        this.user.loading = false;
                        return;
                    }
                    this.daily_data = this.featureSet.monthly_data;
                    break;
            }
        }


        if(this.daily_data.length === 0){
            this.hasNoData = true;
            this.user.loading = false;
            return;
        }

        this.hasNoData = this.daily_data.find(element => {
            element == null || element.value === null || this.daily_data.length === 0;
        });

        this.user.loading = false;
    }

    async showEco7(featureId) {
        let data = this.user.loadFromLocalStorage('eco7-' + featureId);
        data.subscribe((res: any) => {
            if (!res || res.expires < Date.now()) {
                this.eco7Data = this.dataAnalytics.getECO7(featureId);
                this.eco7Data.subscribe((response) => {
                    this.user.saveToLocalStorage('eco7-' + featureId, response);
                });
            } else {
                this.eco7Data = data.pipe(map((a) => a.obj));
            }
        });
    }

    async showCustomTimeSpan(startDate: Date, endDate: Date) {
        this.startTime = startDate.getTime();
        this.endTime = endDate.getTime();
        const energyFeature = this.findFeature("energy");
        const powerFeature = this.findFeature("power");
        let energyRange = this.dataAnalytics.getDaysBetween(this.startTime, this.endTime);
        this.daily_data = await this.dataAnalytics.getCustomDateRange(energyFeature.featureId, energyRange, this.startTime, this.endTime, "energy");
        this.showGraph(this.featureSet);
    }


    private findFeature(featureType: string) {
        for (let featureIndex in this.features) {
            let feature = this.features[featureIndex];
            if (feature.attributes.type === featureType) {
                return feature;
            }
        }
        return undefined;
    }


    async showHourlyDistribution(featureId) {
        let data = this.user.loadFromLocalStorage('average-half-hour-' + featureId);
        data.subscribe((res: any) => {
            if (!res || res.expires < Date.now()) {
                this.hourlyAverage = this.dataAnalytics.getHourlyAverage(featureId, this.endTime);
                this.hourlyAverage.subscribe((response) => {
                    this.user.saveToLocalStorage('average-half-hour-' + featureId, response);
                });
            } else {
                this.hourlyAverage = data.pipe(map((a) => a.obj));
            }
        });
    }

    changeRoute() {
        this.activeGraph.destroyGraphs();
        const url = this.rout.url;
        const newUrl = url.replace('energy', 'switch');
        this.rout.navigateByUrl(newUrl);
    }



    changeTimeSpan(value) {
        this.daily_data = undefined;
        this.hasNoData = true;
        let currentDate = Date.now();
        if (value !== "custom") {
            this.timespan = value;
            let startDate;
            switch (value) {
                case "weekly":
                    this.daily_data = this.featureSet.daily_data;
                    startDate = currentDate - time.day * 7;
                    break;
                case "monthly":
                    this.daily_data = this.featureSet.monthly_data;
                    startDate = currentDate - time.day * 31;
           
                    break;
            }
            this.currentTimespanString = new Date(startDate).toDateString() + " - " + new Date(currentDate).toDateString();
            this.showGraph(this.featureSet);
            return;
        }

        this.dialog.open(TimeSelectComponent).afterClosed().subscribe(res => {
            if (!res.timeSelected) {
                return;
            }

            this.timespan = "custom";
            this.currentTimespanString = res.startDate.toDateString() + " - " + res.endDate.toDateString();
            this.showCustomTimeSpan(res.startDate, res.endDate);
        })

    }

    displayProductCode(productCode) {
        return this.icons.getProductCodeDisplay(productCode);
    }

    onExportClick() {
        this.dialog.open(PopupComponent).afterClosed().subscribe(res => {
            this.dataExport.exportData(this.featureSet, this.daily_data, res, this.timespan);
        });
    }

}